// extracted by mini-css-extract-plugin
export default {"wrapper":"TabNavigation_wrapper__GhB2Z","link":"TabNavigation_link__idItG","active":"TabNavigation_active__hLDv+"};